import React, { useContext, useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import QuickBuyContext from '@context/QuickBuyContext'
import StarRating from '@components/common/StarRating'
import InputField from '@components/common/InputField'
//import DragAndDropZone from '@components/common/DragAndDropZone'
import { MockProducts } from '@mockdata/mockdata'
import { Toast } from '@components/ToastTemplates/Toast'

const WriteAReview = ({ product }) => {
  const { setShowWriteReview } = useContext(QuickBuyContext)
  const [isLoggedIn, setIsLoggedIn] = useState(false)
  const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [title, setTitle] = useState('')
  const [reviewMessage, setReviewMessage] = useState('');
  const [rating, setRating] = useState(5)
  const [isSubmitting, setIsSubmitting] = useState(false)
  //const [uploadedFiles, setUploadedFiles] = useState([]);

  const productNameVariant = product?.title?.split(" / ")

  const handlePostReview = async () => {

    setIsSubmitting(true)

    const reviewData = {
        productId: product?.shopifyId?.replace("gid://shopify/Product/", ""),
        rating: rating,
        reviewMessage: reviewMessage,
        author: name,
        email: email,
        title: title
    };

    // 
    /*
    const uploadedFilesData = uploadedFiles.map(file => {
        // Convert files to base64 or handle accordingly
        return file;
    });
    reviewData.images = uploadedFilesData;
    */

    
    try {
        const response = await fetch("/.netlify/functions/submit-review", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(reviewData),
        });

        
        const contentType = response.headers.get("Content-Type");
        if (contentType && contentType.includes("application/json")) {
            const result = await response.json();

            if (result.error && result.error !== "The underlying provider failed on Open.") {
                const toastId = toast(
                    <Toast
                        title={"Error!"}
                        message={"Please fill up all the fields."}
                        type={'danger'}
                        handleClose={() => toast.dismiss(toastId)}
                    />)
                setIsSubmitting(false);
            } else if (result.error && result.error === "The underlying provider failed on Open.") {
                const toastId = toast(
                    <Toast
                        title={"System Error!"}
                        message={"There is an error submitting your review, Please try again later."}
                        type={'danger'}
                        handleClose={() => toast.dismiss(toastId)}
                    />)
                setIsSubmitting(false);
            }else {
                const toastId = toast(
                    <Toast
                        title={"Thank you for your review!"}
                        message={"Your feedback help us improve and share better products with you."}
                        type={'success'}
                        handleClose={() => toast.dismiss(toastId)}
                    />)

                    setName('')
                    setEmail('')
                    setTitle('')
                    setReviewMessage('')
                    setRating(5)

                    setIsSubmitting(false);
            }
        }
    } catch (error) {
        const toastId = toast(
            <Toast
                title={"System error!"}
                message={"There is an error submitting your review, Please try again later."}
                type={'danger'}
                handleClose={() => toast.dismiss(toastId)}
            />)
        setIsSubmitting(false);
    }
};


  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      setIsLoggedIn(true)
    }
  }

  return (
    <React.Fragment>
      <section className="space-y-8">
        <div className="my-4">
          <div className="border-t border-b border-gray-300 py-6 mb-4">
            <section className="flex flex-nowrap gap-x-4">
              <div>
                <img
                  src={product?.featuredImage?.src}
                  alt={product?.title}
                  className="max-w-[53px]"
                  loading="lazy"
                />
              </div>
              <div className="flex-1">
                <h1 className="font-semibold text-lg mr-10">{productNameVariant?.[0]?.replace("FINAL SALE", "")}</h1>
                <div className="inline-flex gap-x-1 text-sm items-center text-tertiary">
                  <span>{productNameVariant?.[1]?.replace("FINAL SALE", "")}</span>
                </div>
              </div>
            </section>
          </div>

          <StarRating
            className="justify-center gap-x-4"
            size={28}
            initalRating={rating}
            showStarLabels
            setRating={setRating}
          />
        </div>

        <div className="py-4 space-y-2 text-[#6D6D6D]">
          
          <InputField
              id="title"
              label="TITLE"
              placeholder="Title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e)} // temp event. remove as needed
              labelOnTop
            />
          <div className="flex flex-nowrap justify-between text-sm">
            <span>REVIEW</span>
            
          </div>
          <textarea
            id={"comment"}
            className="w-full p-3.5 text-sm border border-gray-600 text-tertiary"
            rows={4}
            value={reviewMessage}
            onChange={(e) => setReviewMessage(e.target.value)}
          />
          <p>
            Tell us what you loved (or didn’t)! Share your honest thoughts to
            help others find their perfect fit.
          </p>
        </div>

        {!isLoggedIn ? (
          <div className="space-y-2">
            <InputField
              id="name"
              label="NAME"
              placeholder="Enter your name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e)} // temp event. remove as needed
              labelOnTop
            />
            <InputField
              id="email"
              label="EMAIL"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyDown={(e) => handleKeyDown(e)} // temp event. remove as needed
              labelOnTop
            />
          </div>
        ) : (
          <div className='flex gap-2 items-center'>
            <span>Reviewing as,</span>
            <img className='w-6 h-6 rounded-full' src={MockProducts[0].image} alt={name} />
            <span className='font-semibold'>{name}</span>
          </div>
        )}
        {
            /*
            <div className='space-y-4 text-sm'>
          <span>PHOTOS</span>
          <DragAndDropZone setUploadedFiles={setUploadedFiles} />
        </div>
            */
        }
        

        <div className={`bg-white sticky bottom-0 left-0 w-full pb-4 z-50`}>
          <div className="flex flex-nowrap gap-x-2">
            <button
              className="btn-outline flex items-center justify-center p-3 flex-1"
              onClick={() => setShowWriteReview(false)}
              aria-label="Cancel"
              disabled={isSubmitting}
            >
              Cancel
            </button>
            <button
              className="btn-primary flex items-center justify-center p-3 flex-1"
              onClick={() => handlePostReview()}
              aria-label="Post Review"
              disabled={isSubmitting}
            >
              Post Review
            </button>
          </div>
        </div>
      </section>
    </React.Fragment>
  );
}

export default WriteAReview